export const ScreenNames = {
    MAP_PROFILE_FEED: 'Map Profile Feed',
    POST_SCREEN: 'Post Screen',
    STEP_PROFILE: 'Step Profile',
    USER_PROFILE_FEED: 'User Profile Feed',
};
